import { render, staticRenderFns } from "./TabelaCadastrosVuetfy.vue?vue&type=template&id=6619860a"
import script from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
export * from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastrosVuetfy.vue?vue&type=style&index=0&id=6619860a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports